/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Clear_ConfirmInputs */



/**
* | output |
* | --- |
* | "Clear all raffle draws?" |
*
* @param {Raffle_Clear_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_clear_confirm = /** @type {((inputs?: Raffle_Clear_ConfirmInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Clear_ConfirmInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer tous les tirages au sort ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Borrar todos los sorteos?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Limpar todos os sorteios?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancellare tutte le estrazioni?")
	return /** @type {LocalizedString} */ ("Clear all raffle draws?")
});